export default __webpack_public_path__ + "static/media/instagram.fbae9d49.svg";